import { render, staticRenderFns } from "./wx-service.vue?vue&type=template&id=36535e65&scoped=true"
import script from "./wx-service.vue?vue&type=script&lang=js"
export * from "./wx-service.vue?vue&type=script&lang=js"
import style0 from "./wx-service.vue?vue&type=style&index=0&id=36535e65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36535e65",
  null
  
)

export default component.exports